module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', [_c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "仓库列表"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "仓库列表",
      "disabled": !_vm.filters.IsAdmin
    },
    model: {
      value: (_vm.postData.WID),
      callback: function($$v) {
        _vm.$set(_vm.postData, "WID", $$v)
      },
      expression: "postData.WID"
    }
  }, _vm._l((_vm.warehouses), function(item) {
    return _c('el-option', {
      key: item.DataID,
      attrs: {
        "value": item.DataID,
        "label": ((item.Code) + "  " + (item.Name))
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "盘点单状态"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "盘点单状态"
    },
    model: {
      value: (_vm.postData.Mode),
      callback: function($$v) {
        _vm.$set(_vm.postData, "Mode", $$v)
      },
      expression: "postData.Mode"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": "All"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "未完成",
      "value": "UnComplete"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "已完成",
      "value": "Complete"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "取消",
      "value": "Cancel"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "单号"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "盘点单号/来源单号"
    },
    model: {
      value: (_vm.postData.KeyWord),
      callback: function($$v) {
        _vm.$set(_vm.postData, "KeyWord", $$v)
      },
      expression: "postData.KeyWord"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "时间范围"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "picker-options": _vm.pickerOptions2
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-form-item', [_c('el-autocomplete', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "fetch-suggestions": _vm.querySearchAsync,
      "placeholder": "ID / SKU / Name"
    },
    on: {
      "select": _vm.handleSelectSearch
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.mainList,
      "highlight-current-row": "",
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "DataID",
      "label": "ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "OrderID",
      "label": "单号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ReferenceID",
      "label": "来源单号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "总数 / 已盘点"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_vm._v("\n            " + _vm._s(s.row.Count.Quantity) + " / " + _vm._s(s.row.Count.Inventory) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Count.percent",
      "label": "盘点进度"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Status",
      "label": "状态"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_vm._v("\n            " + _vm._s(s.row.Date)), _c('br'), _c('span', {
          staticStyle: {
            "font-size": "12px",
            "color": "gray"
          }
        }, [_vm._v(_vm._s(s.row.UpdateDate))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.handleGetCheckDetail(s.row.DataID, 'check')
            }
          }
        }, [_vm._v("查看")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.handleGetCheckDetail(s.row.DataID, 'log')
            }
          }
        }, [_vm._v("日志")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next, jumper",
      "page-size": _vm.pageSize,
      "page-sizes": [20, 30, 50, 100],
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-88ddd0ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/check/checkList.vue
// module id = 843
// module chunks = 1